/**
 * @class
 * @extends mkE.Base
 */
T.EventsList = Class(
	/**
	 * @lends {EventsList#}
	 */
	{
		__construct: function(section, par) {
			this.section = section;
			this.par = par;
			this.node = mkE({
				tag: 'div',
				id: 'T__EventsList'
			});

			this._mGetFilter = new DR.events.GetFilter();
			this._mGetFilter.onLoad = this.drawList;
			this.section.apiCall.addMethod(this._mGetFilter);
		},

		drawList() {
			if (!this._list) {
				this._list = new T.EventsSearchList(
					this.section.url,
					this._mGetFilter,
					this.drawMap,
					this.par
				);
			}
			if (this._map) {
				this._map.remove();
			}
			this._list.append(this.node);
			// Mobile
			if (D.CSS.brTablet) {
				this.section.removeBodyClass('popup-open');
			}
			this._list.search();
		},

		_lastMapCountry: null,

		drawMap() {
			if (!this._map) {
				this._map = new T.EventsSearchMap({
					method: this._mGetFilter,
					drawList: this.drawList
				});
			}
			if (this._list) {
				this._list.remove();
			}
			this._map.append(this.node);
			// Mobile
			if (D.CSS.brTablet) {
				this.section.addBodyClass('popup-open');
			} else {
				D.scrollIntoView(this.node);
			}
			let country = this._list._filter.getCountry() || '';
			if (this._lastMapCountry !== country) {
				this._lastMapCountry = country;
				let countries = this._mGetFilter.re.countries;
				if (!country && D.LANG !== 'en' && countries.indexOf(D.LANG) !== -1) {
					country = D.LANG;
				}
				let bounds;
				let centroid = this._mGetFilter.re.countryBounds[country] || null;
				if (centroid) {
					bounds = {
						south: centroid.south,
						west: centroid.west,
						north: centroid.north,
						east: centroid.east
					};
				} else {
					// Europe
					bounds = {south: 34, west: -11, north: 65, east: 55};
				}
				this._map.search(bounds);
			}
		}
	},
	mkE.Base
);